export function isAvailableLicense(maxLicense: number | undefined, countLicense: number | undefined): boolean {
  if (maxLicense === undefined || countLicense === undefined) {
    return false
  } else {
    return maxLicense === -1 || countLicense < maxLicense
  }
}
